import React from 'react';
import { Link } from 'react-router-dom';
import LogoMark from './LogoMark';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-12 pb-16 md:pb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">

        {/* Main grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-8 sm:gap-8 mb-10">

          {/* Brand */}
          <div className="sm:col-span-3 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-3">
              <LogoMark />
              <span className="text-white font-display text-xl font-extrabold">TheAirlineFares</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Independent travel agency providing flight booking assistance and customer support for domestic and international travel.
            </p>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Company</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">Terms &amp; Conditions</Link></li>
              <li><Link to="/refund-policy" className="hover:text-white transition-colors">Refund Policy</Link></li>
              <li><Link to="/service-fees" className="hover:text-white transition-colors">Service Fees</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Support</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="tel:+18887788606" className="hover:text-amber-400 transition-colors">+1 (888) 778-8606</a></li>
              <li><a href="mailto:support@theairlinefares.com" className="hover:text-white transition-colors">support@theairlinefares.com</a></li>
              <li className="text-gray-400">Mon – Sun: 24 / 7</li>
            </ul>
          </div>

          {/* Business Info */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Business Info</h3>
            <ul className="space-y-2 text-sm text-gray-400 leading-relaxed">
              <li>9100 Cherry Ave<br />Morton Grove, IL 60053<br />United States</li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-700 pt-6 mb-6">
          <p className="text-xs text-gray-500 leading-relaxed">
            <strong className="text-gray-400">Disclaimer:</strong> TheAirlineFares is an independent travel agency and is not affiliated with, endorsed by, or associated with any airline, airport, government agency, or travel provider. Airline names, logos, and trademarks are the property of their respective owners and are used for identification purposes only.
          </p>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <span>© {new Date().getFullYear()} Skyfare Services Inc. All rights reserved.</span>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/about" className="hover:text-gray-300 transition-colors">About Us</Link>
            <Link to="/contact" className="hover:text-gray-300 transition-colors">Contact Us</Link>
            <Link to="/privacy-policy" className="hover:text-gray-300 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-gray-300 transition-colors">Terms</Link>
            <Link to="/refund-policy" className="hover:text-gray-300 transition-colors">Refund Policy</Link>
            <Link to="/service-fees" className="hover:text-gray-300 transition-colors">Service Fees</Link>
          </div>
        </div>

      </div>
    </footer>
  );
}
